/**
 * Threada - Bundle Builder + Per-Product Customizer (Optimized v2)
 * Dependencies: jQuery, Select2
 *
 * Flow:
 *   1. Bundle product selection (colors, sizes, quantities)
 *   2. Customizer popup: Per-product logo assignment
 *      a. Product list → Per-category steps
 *      b. Application method → Positions → Logo assignment style
 *      c. Same logo for all OR different logo per position
 *      d. Summary with pricing → Add to cart
 */

(function ($) {
  'use strict';

  /* ──────────────────────────────────────────────
     CONFIG & STATE
  ────────────────────────────────────────────── */
  var customization = !$('.mrk-direct-bundle-add').length;
  var moneyFormat = window.theme ? window.theme.moneyFormat : '£{{amount}}';

  // Per-category customization data store
  var categoryData = {};
  var currentCategory = null;
  var currentPositionIndex = 0;

  /* ──────────────────────────────────────────────
     LOGO STORAGE (localStorage)
  ────────────────────────────────────────────── */
  var LOGO_STORAGE_KEY = 'threada_uploaded_logos';

  function saveLogoToStorage(url, name) {
    try {
      var logos = JSON.parse(localStorage.getItem(LOGO_STORAGE_KEY) || '[]');
      if (!logos.find(function (l) { return l.url === url; })) {
        logos.unshift({ url: url, name: name || url.split('/').pop(), date: Date.now() });
        logos = logos.slice(0, 20); // keep max 20
        localStorage.setItem(LOGO_STORAGE_KEY, JSON.stringify(logos));
      }
    } catch (e) { console.warn('Could not save logo to storage:', e); }
  }

  function loadExistingLogos(catHandle) {
    try {
      var logos = JSON.parse(localStorage.getItem(LOGO_STORAGE_KEY) || '[]');
      var $container = $('.popup-step[data-step="existing-logo-' + catHandle + '"] .mrk-existing-items');
      $container.empty();

      if (!logos.length) {
        $container.html('<p class="existing-logos__empty">No previously uploaded logos found. Upload a logo first and it will appear here.</p>');
        return;
      }

      var html = '<p class="existing-logos__hint">Select a previously uploaded logo:</p><div class="existing-logos-grid">';
      logos.forEach(function (logo) {
        html += '<div class="existing-logo-item" data-url="' + logo.url + '" data-category="' + catHandle + '" title="' + logo.name + '">' +
          '<div class="existing-logo-item__img"><img src="' + logo.url + '" alt="' + logo.name + '" loading="lazy"></div>' +
          '<div class="existing-logo-item__name">' + logo.name + '</div>' +
          '<div class="existing-logo-item__check"><svg width="16" height="16" viewBox="0 0 22 22" fill="none"><circle cx="11" cy="11" r="11" fill="#22c55e"/><path d="M6 11l3.5 3.5L16 8" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg></div>' +
          '</div>';
      });
      html += '</div>';
      $container.html(html);
    } catch (e) { console.warn('Could not load logos from storage:', e); }
  }

  /* ──────────────────────────────────────────────
     UTILITY: Format Money
  ────────────────────────────────────────────── */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var formatString = format || moneyFormat;
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision || 2;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsStr = parts[1] ? decimal + parts[1] : '';
      return dollars + centsStr;
    }

    var value = '';
    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_single': value = formatWithDelimiters(cents, 1); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
    }
    return formatString.replace(placeholderRegex, value);
  }

  /* ──────────────────────────────────────────────
     UTILITY: File Upload
  ────────────────────────────────────────────── */
  function preparePreview(file, container) {
    $(container).find('.mrk-progress').show();
    $(container).find('.mrk-upload').css('width', '0%');
    $(container).find('.mrk-error-message span').text('');
    $(container).find('.mrk-filename span[data-mrk-name]').text(file.name);
    $(container).find('.preview-template').show();
  }

  function uploadFile(file, container) {
    var formData = new FormData();
    formData.append('file', file);

    $.ajax({
      url: 'https://threada.xyz',
      type: 'POST',
      data: formData,
      cache: false,
      contentType: false,
      processData: false,
      beforeSend: function () {
        $('.mrk-steps-footer').addClass('loading');
      },
      xhr: function () {
        var xhr = new XMLHttpRequest();
        xhr.upload.addEventListener('progress', function (e) {
          if (e.lengthComputable) {
            var pct = (e.loaded / e.total) * 100;
            $(container).find('.mrk-upload').css('width', pct + '%');
          }
        });
        return xhr;
      },
      success: function (response) {
        var url = response.url;
        $(container).find('[data-mrk-thumbnail]').attr('src', url);
        $(container).find('.input-file-logo').val(url).change();
        $(container).find('.mrk-progress').hide();
        $('.mrk-steps-footer').removeClass('loading mrk-disable-btn');

        // ── Save to localStorage for reuse in "Existing Logo" step ──
        saveLogoToStorage(url, file.name);
      },
      error: function (err) {
        console.error('Upload failed:', err);
        $(container).find('.mrk-error-message span').text('Upload failed. Please try again.');
        $(container).find('.mrk-progress').hide();
        $('.mrk-steps-footer').removeClass('loading');
      }
    });
  }

  /* ──────────────────────────────────────────────
     BUNDLE BUILDER: Tab Navigation
  ────────────────────────────────────────────── */
  function initTabNavigation() {
    $('.go-to-item').on('click', function () {
      var id = $(this).attr('id');
      $('.go-to-item').removeClass('bundle__build-item--active');
      $(this).addClass('bundle__build-item--active');
      $('.mrk-bundle-products-items').removeClass('mrk-bundle-active');
      $('[mrk-bundle-products=' + id + ']').addClass('mrk-bundle-active');

      $('.bundle_inside_wrap').removeClass('mx_active');
      $(this).closest('.bundle_inside_wrap').addClass('mx_active');

      updateNextPrevButton();
      $('[mrk-bundle-products=' + id + ']')[0].scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
    });

    $('.next-bundle-product').on('click', function () {
      var $current = $('.bundle__build-item.bundle__build-item--active');
      var $next = $current.closest('.bundle_inside_wrap').next('.bundle_inside_wrap:not(.has_empty)').find('.go-to-item');
      if ($next.length) $next.click();
    });

    $('.previous-bundle-product').on('click', function () {
      var $current = $('.bundle__build-item.bundle__build-item--active');
      var $prev = $current.closest('.bundle_inside_wrap').prev('.bundle_inside_wrap').find('.go-to-item');
      if ($prev.length) $prev.click();
    });
  }

  /* ──────────────────────────────────────────────
     BUNDLE BUILDER: Product Accordion
  ────────────────────────────────────────────── */
  function initAccordion() {
    $('.mixmatch-open').on('click', function () {
      $(this).toggleClass('active');
      $(this).closest('.bundle__details').toggleClass('bundle__details--open');
      $(this).parents('.bundle__details').find('.bundle__details-inner').slideToggle('fast');
    });
  }

  /* ──────────────────────────────────────────────
     BUNDLE BUILDER: Color Selection (Select2)
  ────────────────────────────────────────────── */
  function initColorPicker() {
    function formatState(state) {
      if (!state.id) return state.text;
      var color = $(state.element).data('color');
      return $(
        '<span class="detail__swatch">' +
        '<span class="detail__colour-swatch"><span style="background:' + color + ';"></span></span>' +
        '<span class="detail__text">' + state.text + '</span></span>'
      );
    }

    $('.mrk-color-picker').select2({
      templateResult: formatState,
      templateSelection: formatState,
      placeholder: 'Select Colors'
    });

    $('.mrk-color-picker').on('select2:select select2:unselect', function () {
      var selectedOptions = $(this).val();
      var $inner = $(this).parents('.bundle__details-inner');
      if (selectedOptions && selectedOptions.length > 0) {
        $inner.find('.bundle__no-colours').addClass('hide-no-colours');
      } else {
        $inner.find('.bundle__no-colours').removeClass('hide-no-colours');
      }
      renderData($(this));
    });
  }

  /* ──────────────────────────────────────────────
     BUNDLE BUILDER: Size/Variant Rendering
  ────────────────────────────────────────────── */
  function renderData(select) {
    $('.mrk-bundle-loader-main').css('display', 'flex');
    var selectedOptions = $(select).find('option:selected');
    var ajaxCalls = [];

    selectedOptions.each(function () {
      var variantUrl = $(this).attr('varianturl') + '&view=bundleSizes';
      if (variantUrl) {
        ajaxCalls.push($.ajax({ url: variantUrl, method: 'GET', cache: true }));
      }
    });

    if (ajaxCalls.length === 0) {
      $(select).parents('.bundle__details').find('.bundle__details-inner .bundle__colour-options').html('');
      $('.mrk-bundle-loader-main').hide();
      return;
    }

    $.when.apply($, ajaxCalls).then(function () {
      var combinedHtml = '';
      if (ajaxCalls.length > 1) {
        $.each(arguments, function (idx, responseData) {
          combinedHtml += responseData[0];
        });
      } else {
        combinedHtml = arguments[0];
      }
      $(select).parents('.bundle__details').find('.bundle__details-inner .bundle__colour-options').html(combinedHtml);
      $('.mrk-bundle-loader-main').hide();
      bindQtyEvents();
      updateFeaturedImage(select);
    });
  }

  /* ──────────────────────────────────────────────
     BUNDLE BUILDER: Featured Image Update on Color Select
  ────────────────────────────────────────────── */
  function updateFeaturedImage(select) {
    var $details = $(select).parents('.bundle__details');
    var firstSelected = $(select).find('option:selected').first();
    if (firstSelected.length) {
      var $firstColorOption = $details.find('.bundle__colour-option').first();
      if ($firstColorOption.length) {
        var imgSrc = $firstColorOption.find('.product-info-image img').attr('src');
        if (imgSrc) {
          $details.find('.bundle__item-featured-image').attr('src', imgSrc);
        }
      }
    }
  }

  /* ──────────────────────────────────────────────
     BUNDLE BUILDER: Quantity Events
  ────────────────────────────────────────────── */
  function bindQtyEvents() {
    $('.bundle__details-inner [data-action="decrement"]').off('click').on('click', function () {
      var $input = $(this).parents('.stock').find('.mrk-qty-item');
      var currentValue = parseInt($input.val(), 10);
      var minValue = parseInt($input.attr('min'), 10) || 0;
      if (currentValue > minValue) {
        $input.val(currentValue - 1);
      }
      updateTotals();
    });

    $('.bundle__details-inner [data-action="increment"]').off('click').on('click', function () {
      var $input = $(this).parents('.stock').find('.mrk-qty-item');
      var currentValue = parseInt($input.val(), 10);
      var total = 0;
      var limit = Number($('.bundle__build-item--active').attr('limit'));
      $(this).parents('.bundle__colour-options').find('.mrk-qty-item').each(function () {
        total += Number($(this).val());
      });
      if (total > limit) {
        $input.val(0);
        alert('You can add a maximum of ' + limit + ' items.');
        return;
      }
      if (total === limit) {
        updateTotals();
        return;
      }
      var maxValue = parseInt($input.attr('max'), 10) || 100;
      if (currentValue < maxValue) {
        $input.val(currentValue + 1);
      }
      updateTotals();
    });

    $('.bundle__details-inner .mrk-qty-item').off('change').on('change', function () {
      var total = 0;
      var limit = Number($('.bundle__build-item--active').attr('limit'));
      $(this).parents('.bundle__colour-options').find('.mrk-qty-item').each(function () {
        total += Number($(this).val());
      });
      if (total > limit) {
        $(this).val(0);
        alert('You can add a maximum of ' + limit + ' items.');
        return;
      }
      updateTotals();
    });
  }

  /* ──────────────────────────────────────────────
     BUNDLE BUILDER: Update Totals
  ────────────────────────────────────────────── */
  function updateTotals() {
    var limit = Number($('.bundle__build-item--active').attr('limit'));
    var bundleItemTotal = 0, bundleTotal = 0;

    $('.mrk-bundle-active .mrk-qty-item').each(function () {
      var val = Number($(this).val());
      if (val > 0) bundleItemTotal += val;
    });

    $('.bundle__build-item--active .current_quantity_130').text(bundleItemTotal);

    var remaining = limit - bundleItemTotal;
    var $wrap = $('.bundle__build-item--active').closest('.bundle_inside_wrap');
    if (remaining > 0) {
      $wrap.find('.mbs_selection').text('Only ' + remaining + ' to Select');
    } else {
      $wrap.find('.mbs_selection').text('Complete!');
    }

    $('.mrk-bundle-active .mrk-selected-qty-text').each(function () {
      if (bundleItemTotal > 0 && bundleItemTotal < limit) {
        $(this).show().find('.mrk-selected-qty').text(remaining);
      } else {
        $(this).hide();
      }
    });

    if (bundleItemTotal === limit) {
      $('.mrk-bundle-active .bundle__colour-options').addClass('mrk-options-disabled');
      $('.bundle__build-item--active').addClass('bundle__build-item--completed');
      $('.mrk-bundle-active .mixmatch-open.active').each(function () {
        $(this).removeClass('active');
        $(this).closest('.bundle__details').removeClass('bundle__details--open');
        $(this).parents('.bundle__details').find('.bundle__details-inner').slideUp('fast');
      });

      setTimeout(function () {
        var $activeItem = $('.bundle__build-item--active');
        var $currentWrap = $activeItem.closest('.bundle_inside_wrap');
        var $nextWrap = $currentWrap.next('.bundle_inside_wrap').not('.has_empty');
        console.log($currentWrap, $nextWrap);
        if ($nextWrap.length) {
          $activeItem.removeClass('bundle__build-item--active');
          $currentWrap.removeClass('mx_active');
          $('.mrk-bundle-active').removeClass('mrk-bundle-active');

          var $nextItem = $nextWrap.find('.go-to-item');
          var nextId = $nextItem.attr('id');
          $nextItem.addClass('bundle__build-item--active');
          $nextWrap.addClass('mx_active');
          $('[mrk-bundle-products="' + nextId + '"]').addClass('mrk-bundle-active');

          var $firstAccordion = $nextWrap.find('.mixmatch-open').first();
          $firstAccordion.addClass('active');
          $firstAccordion.closest('.bundle__details').addClass('bundle__details--open');
          $firstAccordion.closest('.bundle__details').find('.bundle__details-inner').slideDown('fast');

          $nextWrap[0].scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
          updateNextPrevButton();
        } else {
          $('.bundle__build')[0].scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
        }
      }, 400);
    } else if (bundleItemTotal < limit) {
      $('.mrk-bundle-active .bundle__colour-options').removeClass('mrk-options-disabled');
      $('.bundle__build-item--active').removeClass('bundle__build-item--completed');
    }

    $('.mrk-bundle-active .bundle__details--mix-and-match').each(function () {
      var productTotal = 0;
      $(this).find('.mrk-qty-item').each(function () {
        var val = Number($(this).val());
        if (val > 0) productTotal += val;
      });
      $(this).find('.amount-selected').text(productTotal);
    });

    $('.bundle__details--mix-and-match .mrk-qty-item').each(function () {
      var val = Number($(this).val());
      if (val > 0) bundleTotal += val;
    });
    $('.bundle__build .selected_products').text(bundleTotal);
    window.bundleTotal = bundleTotal;
    updateNextPrevButton();
  }

  /* ──────────────────────────────────────────────
     BUNDLE BUILDER: Next/Prev + Add Logo Button
  ────────────────────────────────────────────── */
  function updateNextPrevButton() {
    var $current = $('.bundle__build-item.bundle__build-item--active');
    var $currentWrap = $current.closest('.bundle_inside_wrap');
    var $prevWrap = $currentWrap.prev('.bundle_inside_wrap');
    var $nextWrap = $currentWrap.next('.bundle_inside_wrap:not(.has_empty)');

    $prevWrap.length ? $('.previous-bundle-product').show() : $('.previous-bundle-product').hide();

    if (window.bundleTotal === window.totalLimit) {
      $('.next-bundle-product').hide();
      $('.mrkfinal-add-logo, .mrk-direct-bundle-add').show();
    } else if ($nextWrap.length) {
      $('.next-bundle-product').show();
      $('.mrkfinal-add-logo, .mrk-direct-bundle-add').hide();
    } else {
      $('.next-bundle-product').hide();
      $('.mrkfinal-add-logo, .mrk-direct-bundle-add').hide();
    }
  }

  /* ──────────────────────────────────────────────
     SIZE GUIDE LINK
  ────────────────────────────────────────────── */
  function initSizeGuide() {
    $(document).on('click', '.custom-size-guide-text-link', function () {
      $('.mrk-sizing-btn').click();
    });
    $(document).on('click', '.product-info-show', function () {
      var $info = $(this).closest('.bundle__colour-option').find('.product-info');
      $info.toggleClass('show');
      $(this).text($info.hasClass('show') ? 'Hide Information' : 'Show Information');
    });
  }

  /* ══════════════════════════════════════════════
     CUSTOMIZER POPUP v5
  ══════════════════════════════════════════════ */

  var stepHistory = [];
  var textLineCounter = {};

  function showStep(stepName) {
    stepHistory.push(stepName);
    $('.popup-step').removeClass('active');
    $('.popup-step[data-step="' + stepName + '"]').addClass('active');
    $('.mrk-customizer-popup-form .popup-overlay').scrollTop(0);

    // Auto-populate existing logos when landing on existing-logo step
    if (stepName.indexOf('existing-logo-') === 0) {
      var catHandle = stepName.replace('existing-logo-', '');
      loadExistingLogos(catHandle);
    }
  }

  function goBack() {
    if (stepHistory.length > 1) {
      stepHistory.pop();
      var prev = stepHistory[stepHistory.length - 1];
      $('.popup-step').removeClass('active');
      $('.popup-step[data-step="' + prev + '"]').addClass('active');
    } else {
      showStep('category-list');
    }
  }

  function generateLogoId() {
    return String(Math.floor(100000 + Math.random() * 900000));
  }

  function buildPerPositionRows(catHandle) {
    var data = categoryData[catHandle];
    if (!data || !data.positions.length) return;

    var $section = $('.per-position-section[data-category="' + catHandle + '"]');
    var $rows = $section.find('.per-position-rows');
    $rows.empty();

    var logoTypes = [];
    $('.same-logo-section[data-category="' + catHandle + '"] .logo-type-btn').each(function () {
      logoTypes.push({
        type: $(this).data('logo-type'),
        variant: $(this).data('variant'),
        price: $(this).data('price'),
        imgSrc: $(this).data('img-src') || $(this).find('.logo-type-btn__circle img').attr('src')
      });
    });

    data.positions.forEach(function (pos) {
      var iconsHtml = '';
      logoTypes.forEach(function (lt) {
        iconsHtml += '<button type="button" class="per-position-icon" data-logo-type="' + lt.type + '" data-variant="' + lt.variant + '" data-price="' + lt.price + '" data-position="' + pos.name + '" data-category="' + catHandle + '">' +
          '<div class="per-position-icon__circle"><img src="' + lt.imgSrc + '" alt="' + lt.type + '"></div>' +
          '<div class="per-position-icon__label">' + lt.type + '</div></button>';
      });

      var posImgSrc = $('[data-step="positions-' + catHandle + '"] .position-card[data-position="' + pos.name + '"]').data('position-img') || '';

      $rows.append(
        '<div class="per-position-row" data-position="' + pos.name + '">' +
          '<div class="per-position-row__thumb"><img src="' + posImgSrc + '" alt="' + pos.name + '"></div>' +
          '<div class="per-position-row__info"><div class="per-position-row__name">' + pos.name + '</div>' +
          '<div class="per-position-row__method">' + pos.appMethod + '</div></div>' +
          '<div class="per-position-row__icons">' + iconsHtml + '</div></div>'
      );
    });
  }

  /* ──────────────────────────────────────────────
     SUMMARY STEP: build with full pricing breakdown
  ────────────────────────────────────────────── */
  function getVolumeTier(tiers, qty) {
    if (!tiers || !tiers.length) return null;
    var match = tiers[0];
    for (var i = 0; i < tiers.length; i++) {
      var parts = tiers[i].qty.split('-');
      var min = parseInt(parts[0], 10);
      var max = parts[1] !== undefined
        ? (parts[1] === '' ? Infinity : parseInt(parts[1], 10))
        : Infinity;
      if (qty >= min && qty <= max) { match = tiers[i]; break; }
    }
    return match;
  }
  function buildSummary() {
    var $content = $('.summary-content');
    $content.empty();

    var vdE = (window.mrkVD && window.mrkVD.embroidery) || [];
    var vdP = (window.mrkVD && window.mrkVD.print)      || [];

    var logoCustomizationTotal = 0;
    var grandTotalQty = 0;
    var summaryHtml = '';

    // ── Pre-pass: GLOBAL bundle qty drives logo tier lookups ──
    $('.mrk-bundle-products-items').each(function () {
      $(this).find('.mrk-qty-item').each(function () {
        var qty = parseInt($(this).val(), 10) || 0;
        if (qty > 0) grandTotalQty += qty;
      });
    });
    if (grandTotalQty === 0) grandTotalQty = 1;

    // ── Logo tier lookups ──
    var embTier   = getVolumeTier(vdE, grandTotalQty);
    var printTier = getVolumeTier(vdP, grandTotalQty);
    var embDiscountPct   = (embTier   && embTier.discount   !== 'No Discount') ? (parseFloat(embTier.discount)   || 0) : 0;
    var printDiscountPct = (printTier && printTier.discount !== 'No Discount') ? (parseFloat(printTier.discount) || 0) : 0;
    var hasLogoDiscount  = embDiscountPct > 0 || printDiscountPct > 0;

    // ── Per-category render ──
    Object.keys(categoryData).forEach(function (catHandle) {
      var data = categoryData[catHandle];
      if (!data || !data.positions.length) return;

      var catTitle = $('.category-card[data-category="' + catHandle + '"]').data('category-title') || catHandle;

      var totalQty = 0;
      var qtyLines = [];
      $('.mrk-bundle-products-items').each(function () {
        var bName = $(this).attr('bundleitemname') || '';
        var bHandleNorm = bName.toLowerCase().replace(/[^a-z0-9]+/g, '-');
        var catHandleNorm = catHandle.toLowerCase().replace(/[^a-z0-9]+/g, '-');
        var catTitleNorm = catTitle.toLowerCase().replace(/[^a-z0-9]+/g, '-');
        var isMatch = catTitle === bName || catHandleNorm === bHandleNorm || catTitleNorm === bHandleNorm;
        if (!isMatch) return;

        $(this).find('.mrk-qty-item').each(function () {
          var qty = parseInt($(this).val(), 10) || 0;
          if (qty > 0) {
            totalQty += qty;
            var size = $(this).attr('size') || '';
            if (size) qtyLines.push(qty + ' × ' + size);
          }
        });
      });

      if (totalQty === 0) totalQty = 1;

      var html = '<div class="summary-category">';
      html += '<h3 class="summary-category__title">' + catTitle + '</h3>';
      html += '<table class="summary-table">';
      html += '<thead><tr><th>Position</th><th>Method</th><th>Logo</th><th class="summary-table__price">Price</th></tr></thead>';
      html += '<tbody>';

      data.positions.forEach(function (pos) {
        var logo = data.assignmentStyle === 'same' ? data.logos.shared : data.logos.perPosition[pos.name];
        var logoTypeLabel = logo ? logo.type : '—';

        var basePriceEach = pos.appMethod === 'Embroidery' ? pos.embroideryPrice : pos.printPrice;
        var logoTier = pos.appMethod === 'Embroidery' ? embTier : printTier;
        var logoDiscountPct = (logoTier && logoTier.discount !== 'No Discount')
          ? (parseFloat(logoTier.discount) || 0) : 0;

        var lineBaseTotal = basePriceEach * totalQty;
        var discountCents = Math.round(lineBaseTotal * (logoDiscountPct / 100));
        var lineTotal     = lineBaseTotal - discountCents;
        var priceEach     = logoTier ? Math.round(logoTier.price * 100) : basePriceEach;

        logoCustomizationTotal += lineTotal;

        var posImgSrc = $('[data-step="positions-' + catHandle + '"] .position-card[data-position="' + pos.name + '"]').data('position-img') || '';
        var logoPreview = '';
        if (logo && logo.sendArtworkLater) {
          logoPreview = '<span class="summary-logo-text">Artwork to follow</span>';
        } else if (logo && logo.file) {
          logoPreview = '<img class="summary-logo-thumb" src="' + logo.file + '" alt="Logo">';
        } else if (logo && logo.text) {
          logoPreview = '<span class="summary-logo-text">' + logo.text + '</span>';
        }

        var priceCell = priceEach === 0
          ? '<span class="summary-free">Free</span>'
          : formatMoney(priceEach) + ' × ' + totalQty + ' = <strong>' + formatMoney(lineTotal) + '</strong>';

        html += '<tr>' +
          '<td>' +
            (posImgSrc ? '<img class="summary-pos-thumb" src="' + posImgSrc + '" alt="' + pos.name + '">' : '') +
            '<span>' + pos.name + '</span>' +
          '</td>' +
          '<td>' + pos.appMethod + '</td>' +
          '<td>' + logoTypeLabel + (logoPreview ? '<br>' + logoPreview : '') + '</td>' +
          '<td class="summary-table__price">' + priceCell + '</td>' +
          '</tr>';
      });

      html += '</tbody></table>';

      if (qtyLines.length) {
        html += '<p class="summary-category__qty">' + qtyLines.join(', ') + ' <span>(' + totalQty + ' items)</span></p>';
      }

      html += '</div>';
      summaryHtml += html;
    });

    // ── Round logo total only if a logo-tier discount is active ──
    if (hasLogoDiscount) {
      logoCustomizationTotal = Math.ceil(logoCustomizationTotal / 10) * 10;
    }

    // ── Pricing totals block ──
    var bundleBase = window.bundlePrice || 0;
    var grandTotal = bundleBase + logoCustomizationTotal;

    var totalsHtml = '<div class="summary-totals">';
    if (bundleBase > 0) {
      totalsHtml += '<div class="summary-totals__row">' +
        '<span class="summary-totals__label">Bundle price</span>' +
        '<span class="summary-totals__value">' + formatMoney(bundleBase) + '</span>' +
        '</div>';
    }
    if (logoCustomizationTotal > 0) {
      totalsHtml += '<div class="summary-totals__row">' +
        '<span class="summary-totals__label">Logo customisation <a target="_blank" href="/pages/customisation-pricing" class="mrk-learn-more">See our pricing</a></span>' +
        '<span class="summary-totals__value">' + formatMoney(logoCustomizationTotal) + '</span>' +
        '</div>';
    }
    totalsHtml += '<div class="summary-totals__row summary-totals__row--grand">' +
      '<span class="summary-totals__label">Total</span>' +
      '<span class="summary-totals__value">' + formatMoney(grandTotal) + '</span>' +
      '</div>';
    totalsHtml += '</div>';

    $content.html(summaryHtml + totalsHtml);
  }

  function markCategoryDone(catHandle) {
    $('.category-card[data-category="' + catHandle + '"]').addClass('done');
  }

  function allCategoriesDone() {
    return $('.category-card').length === $('.category-card.done').length;
  }

  function initPopup() {
    // Open popup
    $('.mrkfinal-add-logo').on('click', function (e) {
      e.preventDefault();
      stepHistory = ['category-list'];
      showStep('category-list');
      $('.mrk-customizer-popup-form .popup-overlay').addClass('show');
    });

    // Close popup
    $('.popup__close.customizer-popup').on('click', function (e) {
      e.preventDefault();
      $('.mrk-customizer-popup-form .popup-overlay').removeClass('show');
    });

    // Direct add (no customization)
    $('.mrk-direct-bundle-add').on('click', function (e) {
      e.preventDefault();
      addBulkItems();
    });

    // Category card → positions
    $(document).on('click', '.category-card', function () {
      var catHandle = $(this).data('category');
      currentCategory = catHandle;
      if (!categoryData[catHandle]) {
        categoryData[catHandle] = { positions: [], assignmentStyle: 'same', logos: { shared: null, perPosition: {} } };
      }
      showStep('positions-' + catHandle);
    });

    // Back button
    $(document).on('click', '.popup-go-back', function () { goBack(); });

    // Position checkbox → toggle app radios + border
    $(document).on('change', '.position-checkbox', function () {
      var $card = $(this).closest('.position-card');
      if (this.checked) {
        $card.addClass('selected');
        $card.find('.position-card__app').slideDown(200);
      } else {
        $card.removeClass('selected');
        $card.find('.position-card__app').slideUp(200);
      }
    });

    // Positions NEXT STEP → collect ONLY checked positions
    $(document).on('click', '.popup-positions-next', function () {
      var catHandle = $(this).data('category');
      var positions = [];

      $('[data-step="positions-' + catHandle + '"] .position-card').each(function () {
        var $cb = $(this).find('.position-checkbox');
        if (!$cb.is(':checked')) return;

        var posName = $(this).data('position');
        var posHandle = $(this).data('position-handle');   // ← was: posName.toLowerCase().replace(/\s+/g, '-')
        var appMethod = $('input[name="app-' + catHandle + '-' + posHandle + '"]:checked').val() || 'Print';

        positions.push({
          name: posName,
          appMethod: appMethod,
          printVariant: $(this).data('print-variant'),
          embroideryVariant: $(this).data('embroidery-variant'),
          printPrice: Number($(this).data('print-price')),
          embroideryPrice: Number($(this).data('embroidery-price'))
        });
      });

      if (positions.length === 0) {
        alert('Please select at least one position.');
        return;
      }

      categoryData[catHandle].positions = positions;
      showStep('logo-assign-' + catHandle);
    });

    // Assignment style toggle
    $(document).on('change', '.assign-radio', function () {
      var catHandle = $(this).closest('.popup-step').data('category');
      var val = $(this).val();
      categoryData[catHandle].assignmentStyle = val;
      $(this).closest('.assignment-cards').find('.assignment-card').removeClass('assignment-card--active');
      $(this).closest('.assignment-card').addClass('assignment-card--active');
      var $step = $(this).closest('.popup-step');
      if (val === 'same') {
        $step.find('.same-logo-section').show();
        $step.find('.per-position-section').hide();
      } else {
        $step.find('.same-logo-section').hide();
        $step.find('.per-position-section').show();
        buildPerPositionRows(catHandle);
      }
    });

    // Logo type click (same mode)
    $(document).on('click', '.logo-type-btn', function () {
      var catHandle = $(this).data('category');
      categoryData[catHandle].currentLogoType = $(this).data('logo-type');
      categoryData[catHandle].currentLogoVariant = $(this).data('variant');
      categoryData[catHandle].currentLogoPrice = $(this).data('price');
      categoryData[catHandle].currentPositionName = null;
      showStep(getLogoStepName($(this).data('logo-type'), catHandle));
    });

    // Per-position icon click
    $(document).on('click', '.per-position-icon', function () {
      var catHandle = $(this).data('category');
      categoryData[catHandle].currentLogoType = $(this).data('logo-type');
      categoryData[catHandle].currentLogoVariant = $(this).data('variant');
      categoryData[catHandle].currentLogoPrice = $(this).data('price');
      categoryData[catHandle].currentPositionName = $(this).data('position');
      showStep(getLogoStepName($(this).data('logo-type'), catHandle));
    });

    // ── Existing logo item: select a previously uploaded logo ──
    $(document).on('click', '.existing-logo-item', function () {
      var url = $(this).data('url');
      var catHandle = $(this).closest('.popup-step').data('category');

      // Visual selection state
      $(this).closest('.existing-logos-grid').find('.existing-logo-item').removeClass('existing-logo-item--selected');
      $(this).addClass('existing-logo-item--selected');

      // Store selected URL so save-logo can use it
      if (!categoryData[catHandle]) categoryData[catHandle] = {};
      categoryData[catHandle].selectedExistingUrl = url;
    });

    // Save logo
    $(document).on('click', '.popup-save-logo', function () {
      var catHandle = $(this).data('category');
      var data = categoryData[catHandle];
      var $step = $(this).closest('.popup-step');
      var logoType = data.currentLogoType;
      var posName = data.currentPositionName;

      var logoData = { type: logoType, variant: data.currentLogoVariant, price: data.currentLogoPrice, logoId: generateLogoId() };

      if (logoType && logoType.toLowerCase().indexOf('text') > -1) {
        logoData.text = $step.find('.bundle-text-line-1').val() || '';
        logoData.text2 = $step.find('.bundle-text-line-2').val() || '';
        var extraLines = [];
        $step.find('.extra-text-lines input').each(function () { if ($(this).val()) extraLines.push($(this).val()); });
        logoData.extraLines = extraLines;
        logoData.font = $step.find('.bundle-font-select').val() || '';
        logoData.color = $step.find('.bundle-color-select').val() || '';
        logoData.notes = $step.find('.bundle-text-notes').val() || '';
      } else if (logoType && logoType.toLowerCase().indexOf('upload') > -1) {
        logoData.file = $step.find('.bundle-uploaded-file').val() || $step.find('.input-file-logo').val() || '';
        logoData.notes = $step.find('.bundle-upload-notes').val() || '';
      } else if (logoType && logoType.toLowerCase().indexOf('later') > -1) {
        logoData.sendArtworkLater = true;
        logoData.notes = $step.find('.bundle-later-notes').val() || '';
      } else {
        logoData.notes = $step.find('.bundle-existing-notes').val() || '';
        if (data.selectedExistingUrl) logoData.file = data.selectedExistingUrl;
        logoData.existing = true;
      }

      if (data.assignmentStyle === 'same' || !posName) {
        data.logos.shared = logoData;
        markCategoryDone(catHandle);
        showStep('category-list');
      } else {
        data.logos.perPosition[posName] = logoData;
        var allDone = data.positions.every(function (p) { return data.logos.perPosition[p.name]; });
        if (allDone) {
          markCategoryDone(catHandle);
          showStep('category-list');
        } else {
          showStep('logo-assign-' + catHandle);
        }
      }
    });

    // Text logo preview
    $(document).on('input', '.logo-form .logo-form__input[type="text"]', function () {
      const lines = $(this).closest('.logo-form').find('.logo-form__input[type="text"]').map(function () {
        return $(this).val();
      }).get().filter(Boolean).join('<br>');

      $(this).closest('.logo-form').find('.bundle-preview-div').html(lines || 'Threada');
    });
    $(document).on('change', '.bundle-font-select', function () {
      $(this).closest('.popup-step').find('.bundle-preview-div').css('font-style', $(this).val());
    });
    $(document).on('change', '.bundle-color-select', function () {
      $(this).closest('.popup-step').find('.bundle-preview-div').css('color', $(this).val());
    });

    // Add text line
    $(document).on('click', '.add-text-line-link', function (e) {
      e.preventDefault();
      var $step = $(this).closest('.popup-step');
      var catHandle = $step.data('category');
      if (!textLineCounter[catHandle]) textLineCounter[catHandle] = 3;
      var lineNum = textLineCounter[catHandle]++;
      $step.find('.extra-text-lines').append(
        '<label class="logo-form__label">Text Line ' + lineNum + '</label>' +
        '<input type="text" class="logo-form__input bundle-extra-text-line" placeholder="e.g Additional text">'
      );
    });

    // File upload
    $(document).on('change', '.hiddenFileInput', function () {
      var container = $(this).closest('.popup-step').length ? $(this).closest('.popup-step') : $(this).closest('.upload-zone');
      var file = this.files[0];
      if (file.type.startsWith('image/')) {
        var r = new FileReader();
        r.onload = function (e) { $(container).find('[data-mrk-thumbnail]').attr('src', e.target.result); };
        r.readAsDataURL(file);
      }
      if (file) { preparePreview(file, container); uploadFile(file, container); }
    });
    $(document).on('click', '.mrk-close-btn', function () {
      var $zone = $(this).closest('.upload-zone');
      if (!$zone.length) $zone = $(this).closest('.popup-step');
      $zone.find('.input-file-logo, .bundle-uploaded-file').val('');
      $zone.find('[data-mrk-thumbnail]').attr('src', '');
      $zone.find('.preview-template').hide();
      $zone.find('.hiddenFileInput').val('');
    });

    // NEXT STEP from category list → summary
    $(document).on('click', '.popup-go-summary', function (e) {
      e.preventDefault();
      if (!allCategoriesDone()) {
        alert('Please complete logo customization for all categories.');
        return;
      }
      buildSummary();
      showStep('summary');
    });

    // FINISH → build meta + add to cart
    $(document).on('click', '.popup-finish', function (e) {
      e.preventDefault();
      buildCustomizationMeta();
      addBulkItems();
    });
  }

  function getLogoStepName(logoType, catHandle) {
    var type = (logoType || '').toLowerCase();
    if (type.indexOf('text') > -1) return 'text-logo-' + catHandle;
    if (type.indexOf('upload') > -1) return 'upload-logo-' + catHandle;
    if (type.indexOf('later') > -1) return 'later-logo-' + catHandle;
    return 'existing-logo-' + catHandle;
  }


  /* ══════════════════════════════════════════════
     CART: Build customization meta
  ══════════════════════════════════════════════ */

  function buildCustomizationMeta() {
    $('.mrk-hidden-fields').empty();
    window._positionVariants = [];

    Object.keys(categoryData).forEach(function (catHandle) {
      var data = categoryData[catHandle];
      if (!data || !data.positions.length) return;

      var totalQty = 0;
      var bundleItemName = '';

      $('.mrk-bundle-products-items').each(function () {
        var bName = $(this).attr('bundleitemname') || '';
        var bHandle = bName.toLowerCase().replace(/[^a-z0-9]+/g, '-');

        var catTitle = $('.category-card[data-category="' + catHandle + '"]').data('category-title') || '';
        var catHandleNorm = catHandle.toLowerCase().replace(/[^a-z0-9]+/g, '-');
        var bHandleNorm = bHandle.toLowerCase().replace(/[^a-z0-9]+/g, '-');

        var isMatch = catTitle === bName || catHandleNorm === bHandleNorm;
        if (!isMatch) return;

        $(this).find('.mrk-qty-item').each(function () {
          var val = Number($(this).val());
          if (val > 0) {
            totalQty += val;
            if (!bundleItemName) bundleItemName = $(this).attr('productname') || bName;
          }
        });
      });

      if (totalQty === 0) totalQty = 1;

      data.positions.forEach(function (pos) {
        var logo = data.assignmentStyle === 'same'
          ? data.logos.shared
          : data.logos.perPosition[pos.name];
        if (!logo) return;

        var isEmbroidery = pos.appMethod === 'Embroidery';
        var variantId = isEmbroidery ? pos.embroideryVariant : pos.printVariant;
        var logoId = logo.logoId || generateLogoId();
        var lineItemKey = variantId + '_' + logoId + '_' + pos.name.replace(/\s+/g, '_');

        window._positionVariants.push({
          id: variantId,
          quantity: totalQty,
          parent_id: window.bundleId,
          properties: {
            '_ParentVariant': window.bundleId,
            '_time': new Date().toISOString(),
            '_bundleHandle': window.bundleHandle || '',
            '_qty': totalQty,
            '_lineItemKey': lineItemKey,
            '_BundleItemName': bundleItemName,
            'Application Method': pos.appMethod,
            'Logo Type': logo.type,
            'Position': pos.name,
            '_logoId': logoId
          }
        });

        var lastItem = window._positionVariants[window._positionVariants.length - 1];
        var lt = (logo.type || '').toLowerCase();
        if (lt.indexOf('text') > -1) {
          lastItem.properties['Logo Text'] = logo.text || '';
          if (logo.text2) lastItem.properties['Logo Text 2'] = logo.text2;
          if (logo.extraLines && logo.extraLines.length) {
            logo.extraLines.forEach(function (line, i) {
              lastItem.properties['Logo Text ' + (i + 3)] = line;
            });
          }
          lastItem.properties['Logo Font'] = logo.font || '';
          lastItem.properties['Logo Color'] = logo.color || '';
          if (logo.notes) lastItem.properties['Note'] = logo.notes;
        } else if (lt.indexOf('upload') > -1) {
          if (logo.file) lastItem.properties['Logo'] = logo.file;
          if (logo.notes) lastItem.properties['Note'] = logo.notes;
        } else if (lt.indexOf('later') > -1) {
          lastItem.properties['Logo'] = 'Customer will send artwork later';
          if (logo.notes) lastItem.properties['Note'] = logo.notes;
        } else {
          if (logo.file) lastItem.properties['Logo'] = logo.file;
          if (logo.notes) lastItem.properties['Note'] = logo.notes;
        }
      });
    });
  }

  function buildItem(id, qty, parentVariantId, property) {
    if (!parentVariantId) return { quantity: qty, id: id };
    return { quantity: qty, id: id, properties: { '_ParentVariant': parentVariantId, '_qty': qty } };
  }

  function buildMainVariant(parentVariantId, qty, bundleItems) {
    var bundle = [];

    bundleItems.each(function () {
      var bundleItemName = $(this).attr('bundleitemname');
      var bundleObject = bundle.find(function (b) { return b.name === bundleItemName; });
      if (!bundleObject) {
        bundleObject = { name: bundleItemName, products: {}, positions: [] };
        bundle.push(bundleObject);
      }

      var matchedCatHandle = null;
      Object.keys(categoryData).forEach(function (catHandle) {
        var catTitle = $('.category-card[data-category="' + catHandle + '"]').data('category-title') || catHandle;
        if (
          catTitle === bundleItemName ||
          catHandle === bundleItemName.toLowerCase().replace(/[^a-z0-9]+/g, '-')
        ) {
          matchedCatHandle = catHandle;
        }
      });

      if (matchedCatHandle && categoryData[matchedCatHandle]) {
        var data = categoryData[matchedCatHandle];

        data.positions.forEach(function (pos) {
          var logo = data.assignmentStyle === 'same'
            ? data.logos.shared
            : (data.logos.perPosition[pos.name] || null);

          var positionEntry = {
            position: pos.name,
            appMethod: pos.appMethod,
            logoType: logo ? logo.type : null
          };

          var lt = (logo.type || '').toLowerCase();
          if (lt.indexOf('text') > -1) {
            positionEntry.text = logo.text || '';
            if (logo.text2) positionEntry.text2 = logo.text2;
            if (logo.extraLines && logo.extraLines.length) positionEntry.extraLines = logo.extraLines;
            positionEntry.font = logo.font || '';
            positionEntry.color = logo.color || '';
            if (logo.notes) positionEntry.notes = logo.notes;
          } else if (lt.indexOf('upload') > -1) {
            if (logo.file) positionEntry.logo = logo.file;
            if (logo.notes) positionEntry.notes = logo.notes;
          } else if (lt.indexOf('later') > -1) {
            positionEntry.sendArtworkLater = true;
            if (logo.notes) positionEntry.notes = logo.notes;
          } else {
            positionEntry.existingLogo = true;
            if (logo.file) positionEntry.logo = logo.file;
            if (logo.notes) positionEntry.notes = logo.notes;
          }

          bundleObject.positions.push(positionEntry);
        });
      }

      var _index = 1;
      $(this).find('.mrk-qty-item').each(function () {
        if (Number($(this).val()) > 0) {
          bundleObject.products['Product_' + _index] = {
            name: $(this).attr('productname'),
            color: $(this).attr('color'),
            size: $(this).attr('size'),
            quantity: Number($(this).val()),
            sku: $(this).attr('sku')
          };
          _index++;
        }
      });
    });

    var properties = {};
    bundle.forEach(function (cat) {
      cat.positions.forEach(function (pos) {
        var prefix = '_' + cat.name + ' › ' + pos.position + ' (' + pos.appMethod + ')';
        properties[prefix + ' › Logo Type'] = pos.logoType || 'Existing Logo';
        if (pos.logo) properties[prefix + ' › Logo'] = pos.logo;
        if (pos.text) properties[prefix + ' › Text'] = pos.text;
        if (pos.existingLogo && !pos.logo) properties[prefix + ' › Logo'] = 'Existing Logo on File';
        if (pos.sendArtworkLater) properties[prefix + ' › Logo'] = 'Customer will send artwork later';
        if (pos.notes) properties[prefix + ' › Note'] = pos.notes;
      });
    });

    var jsonString = JSON.stringify(bundle);
    var bundlePageUrl = 'https://threada.com/pages/bundle?bundle=' + encodeURIComponent(jsonString);
    var newProperties = $.extend({}, { '_bundle': bundlePageUrl, '_bundle_raw': bundle }, properties);

    return { quantity: qty, id: parentVariantId, properties: newProperties };
  }

  async function addBulkItems() {
    var bundleItems = $('.mrk-bundle-products-items');
    var ids = [];
    var parentVariantId = window.bundleId;
    var mainVariant = buildMainVariant(parentVariantId, 1, bundleItems);

    if (customization && window._positionVariants) {
      ids = ids.concat(window._positionVariants);
    }

    ids.push(mainVariant);
    var data = { items: ids };

    if (window.updates !== undefined) {
      $('.mrk-loader-main').css('display', 'flex');
      try {
        await $.post(window.Shopify.routes.root + 'cart/update.js', { updates: window.updates });
        addItemToCart(data, true);
      } catch (err) {
        console.error('Error updating cart:', err);
        addItemToCart(data, false);
      }
    } else {
      addItemToCart(data, false);
    }
  }

  function addItemToCart(data, refreshCart) {
    $.ajax({
      type: 'POST', url: '/cart/add.js', data: data, dataType: 'json',
      beforeSend: function () { $('.mrk-loader-main, .mrk-bundle-loader-main').css('display', 'flex'); },
      success: function () {
        if (refreshCart && typeof updateCart === 'function') {
          $('.mrk-customizer-cart').hide();
          updateCart();
        } else {
          location.pathname = '/cart';
        }
      },
      error: function (err) {
        console.error('Cart add failed:', err);
        alert('There was an error adding items to cart. Please try again.');
        $('.mrk-loader-main, .mrk-bundle-loader-main').hide();
      }
    });
  }

  function calculatePrice() {
    var totalPrice = window.bundlePrice || 0;
    Object.keys(categoryData).forEach(function (catHandle) {
      var data = categoryData[catHandle];
      if (!data) return;
      data.positions.forEach(function (pos) {
        totalPrice += pos.appMethod === 'Embroidery' ? pos.embroideryPrice : pos.printPrice;
      });
    });
    $('.mrk-final-price').html(formatMoney(totalPrice));
  }


  /* ══════════════════════════════════════════════
     INITIALIZATION
  ══════════════════════════════════════════════ */
  $(document).ready(function () {
    initTabNavigation();
    initAccordion();
    initColorPicker();
    initSizeGuide();
    initPopup();
    updateNextPrevButton();
  });
  /* ═══════════════════════════════
   USP MODALS
   ═══════════════════════════════ */
  function openModal(id) {
    $('#modal-' + id).addClass('show');
    $('body').css('overflow', 'hidden');
    setTimeout(function() {
      $('#modal-' + id).find('.mrk-modal-close').focus();
    }, 50);
  }

  function closeModal($overlay) {
    $overlay.removeClass('show');
    if (!$('.mrk-customizer-overlay').hasClass('show')) {
      $('body').css('overflow', '');
    }
  }

  // Open via data-modal link
  $(document).on('click', '[data-modal]', function(e) {
    e.preventDefault();
    openModal($(this).data('modal'));
  });

  // Close via X button or "Got It"
  $(document).on('click', '.mrk-modal-close, [data-modal-close]', function() {
    closeModal($(this).closest('.mrk-modal-overlay'));
  });

  // Close by clicking the backdrop
  $(document).on('click', '.mrk-modal-overlay', function(e) {
    if ($(e.target).hasClass('mrk-modal-overlay')) {
      closeModal($(this));
    }
  });

  // Close on Escape
  $(document).on('keydown', function(e) {
    if (e.key === 'Escape') {
      var $open = $('.mrk-modal-overlay.show');
      if ($open.length) closeModal($open);
    }
  });
})(jQuery);